<template>
    <div class="echart"></div>
</template>

<script>
import util from '../common/util';
import global from '../common/global';

export default {
    emits: ['update'],
    props: {
        initOptions: {
            type: Object,
            default: () => ({})
        },
        options: {
            type: Object,
            default: () => ({})
        },
        notMerge: {
            type: Boolean,
            default: false
        },
        renderer: {
            type: String,
            default: 'canvas'
        },
        relyOn: {
            type: Array,
            default() {
                return [];
            }
        },
        onLoaded: {
            type: Function
        }
    },
    watch: {
        options(value) {
            this.$nextTick(() => {
                !this.isInit && value && this.init();
                this.setOption(value);
            });
        }
    },
    mounted() {
        let load = [];

        //  load  echarts
        load.push(
            util.addScript(
                'https://static.chimeroi.com/lib/echarts.common.v5.js',
                true
            )
        );

        //  load plugin
        for (let i = 0; i < this.relyOn.length; i++) {
            load.push(util.addScript(this.relyOn[i], true));
        }

        this.echartPs = Promise.all(load);
        this.options && this.init();
        global.resize(this.resize);
        this.resizeObserver = new ResizeObserver(entries => {
            this.resize();
        });
        try {
            this.resizeObserver.observe(this.$el);
        } catch (e) {}
    },
    methods: {
        init() {
            if (!this.echartPs) {
                return;
            }
            this.echartPs.then(() => {
                this.onLoaded && this.onLoaded();
                this.echart = window.echarts.init(this.$el, null, {
                    renderer: this.renderer
                });
                this.initOptions && this.echart.setOption(this.initOptions);
                this.options && this.setOption(this.options);
            });
            this.isInit = true;
        },
        setOption(options) {
            if (this.echart && options) {
                this.echart.setOption(options, this.notMerge);
                this.$emit('update');
            }
        },
        resize() {
            this.echart && this.echart.resize();
        }
    },
    unmounted() {
        this.echart && this.echart.dispose(this.$el);
        global.resize(this.resize, true);
        try {
            this.resizeObserver && this.resizeObserver.unobserve(this.$el);
        } catch (e) {}
    }
};
</script>
